import DefaultState   from './DefaultState';

const state = {
  ...DefaultState,
}

if(Spree.accessories){
  Spree.accessories.forEach((accessory) => {
    const found_index = state.accessoriesListInfo.findIndex((acc_info) => acc_info.id === accessory.product_id)
    state.accessoriesListInfo[found_index].selected = true
    state.accessoriesListInfo[found_index].quantity = accessory.quantity
    const selected_variant = state.accessoriesListInfo[found_index].variants.length > 0 ? state.accessoriesListInfo[found_index].variants.find((v) => v.id === accessory.variant_id) : state.accessoriesListInfo[found_index].master
    state.accessoriesListInfo[found_index].selected_variant = _.cloneDeep(selected_variant)
    state.accessories.push(accessory)
  })
}

export default state;